module.exports = __webpack_public_path__ + "img/join-us-3.27af7a7c.png";